import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getEmpleados, createEmpleado, updateEmpleadoById, deleteEmpleadoById, getUsuarios } from "../api";

const FilterTableEmpleado = () => {
  const [Empleados, setEmpleados] = useState([]);
  const [filteredEmpleados, setFilteredEmpleados] = useState([]);
  const [formData, setFormData] = useState({ id: 0, tratamiento: "", id_usuario: "", nombres: "", apellido_paterno: "", apellido_materno: "", telefono_principal: "", telefono_secundario: "", correo: "", puesto: "", fecha_nacimiento: "", fecha_ingreso: "", supervisor: "", id_proyecto: "", creado_por: ""});
  const [isEditing, setIsEditing] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  const fetchDropdownData = async () => {
    try {
      const [usuariosResponse] = await Promise.all([
        getUsuarios(),
      ]);
      setUsuarios(usuariosResponse.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const fetchEmpleados = async () => {
    try {
      const response = await getEmpleados();
      setEmpleados(response.data);
      setFilteredEmpleados(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching empleadoss:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchEmpleados();
    fetchDropdownData();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Empleados.filter((Empleados) =>
        (Empleados.nombres || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (Empleados.apellido_paterno || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (Empleados.apellido_materno || "").toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredEmpleados(filtered);
    } else {
      setFilteredEmpleados(Empleados);
    }
  }, [filterText, Empleados]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateEmpleadoById(formData.id, { tratamiento: formData.tratamiento, id_usuario: formData.id_usuario, nombres: formData.nombres, apellido_paterno: formData.apellido_paterno, apellido_materno: formData.apellido_materno, telefono_principal: formData.telefono_principal, telefono_secundario: formData.telefono_secundario, correo: formData.correo, puesto: formData.puesto, fecha_nacimiento: formData.fecha_nacimiento, fecha_ingreso: formData.fecha_ingreso, supervisor: formData.supervisor, id_proyecto: formData.id_proyecto});
        alert("Empleados actualizado con éxito.");
      } else {
        await createEmpleado(formData);
        alert("Empleados registrado con éxito.");
      }
      setFormData({ id: 0, tratamiento: "", id_usuario: "", nombres: "", apellido_paterno: "", apellido_materno: "", telefono_principal: "", telefono_secundario: "", correo:"", puesto: "", fecha_ingreso: "", fecha_nacimiento: "", supervisor: "", id_proyecto: "" });
      setIsEditing(false);
      fetchEmpleados();
    } catch (error) {
      console.error("Error procesando empleados:", error);
    }
  };

  const handleEdit = (Empleados) => {
    setFormData({
      ...Empleados,
      id_usuario: Empleados.id_usuario ?? "",
      nombres: Empleados.nombres ?? "",
      apellido_paterno: Empleados.apellido_paterno ?? "",
      apellido_materno: Empleados.apellido_materno ?? "",
      telefono_principal: Empleados.telefono_principal ?? "",
      telefono_secundario: Empleados.telefono_secundario ?? "",
      correo: Empleados.correo ?? "",
      puesto: Empleados.puesto ?? "",
      nss: Empleados.nss ?? "",
      curp: Empleados.curp ?? "",
      rfc: Empleados.rfc ?? "",
      fecha_ingreso: Empleados.fecha_ingreso ?? "",
      fecha_nacimiento: Empleados.fecha_nacimiento ?? "",
      supervisor: Empleados.supervisor ?? "",
      id_proyecto: Empleados.id_proyecto ?? "",
      tratamiento: Empleados.tratamiento ?? "",
    });
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, tratamiento: "", id_usuario: "", nombres: "", apellido_paterno: "", apellido_materno: "", telefono_principal: "", telefono_secundario: "", correo:"", puesto: "", fecha_ingreso: "", fecha_nacimiento:"", supervisor: "", id_proyecto: ""  });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este empleados?")) {
      try {
        await deleteEmpleadoById(id);
        alert("Empleados eliminado con éxito.");
        fetchEmpleados();
      } catch (error) {
        console.error("Error eliminando Empleados:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Personal" : "Agregar Personal"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input-form-1"
            disabled={isEditing}
            hidden
          />
        </div>
          <div className="input-group">
          <label className="label2">Titulo</label>
            <select
              name="tratamiento"
              value={formData.tratamiento}
              onChange={handleChange}
              className="input-form-1"
            >
              <option value="C.">Ciudadano(C.)</option>
              <option value="Lic.">Licenciado(Lic.)</option>
              <option value="Ing.">Ingeniero(Ing.)</option>
              <option value="M.Sc.">Maestro en Ciencias(M.Sc.)</option>
              <option value="PhD">Doctor/a (PhD)</option>
            </select>

            <label className="label2">Usuario</label>
            <select
              name="id_usuario"
              value={formData.id_usuario}
              onChange={handleChange}
              className="input-form-1"
            >
              <option value="">Sin acceso al sistema</option>
              {usuarios.map((usuario) => (
                <option key={usuario.id} value={usuario.id}>
                  {usuario.username}
                </option>
              ))}
            </select>

          </div>
          <div className="input-group">
          <label className="label3">Nombres</label>
          <input
            type="text"
            name="nombres"
            value={formData.nombres}
            onChange={handleChange}
            className="input-form-2"
          />
          </div>
          <div className="input-group">
          <label className="label2">Apellido Paterno</label>
          <input
            type="text"
            name="apellido_paterno"
            value={formData.apellido_paterno}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">Apellido Materno</label>
          <input
            type="text"
            name="apellido_materno"
            value={formData.apellido_materno}
            onChange={handleChange}
            className="input-form-1"
          />    
          </div>
          <div className="input-group">
          <label className="label2">Teléfono principal</label>
          <input
            type="text"
            name="telefono_principal"
            value={formData.telefono_principal}
            onChange={handleChange}
            className="input-form-1"
          /> 
          <label className="label2">Teléfono secundario</label>
          <input
            type="text"
            name="telefono_secundario"
            value={formData.telefono_secundario}
            onChange={handleChange}
            className="input-form-1"
          />      
          </div>
          <div className="input-group">
          <label className="label3">Correo&nbsp;</label>
          <input
            type="text"
            name="correo"
            value={formData.correo}
            onChange={handleChange}
            className="input-form-2"
          />
          </div>
          <div className="input-group">
          <label className="label2">Fecha de Nacimiento</label>
          <input
            type="date"
            name="fecha_nacimiento"
            value={formData.fecha_nacimiento}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">NSS</label>
          <input
            type="text"
            name="nss"
            value={formData.nss}
            onChange={handleChange}
            className="input-form-1"
          />
          </div>
          <div className="input-group">
          <label className="label2">CURP</label>
          <input
            type="text"
            name="curp"
            value={formData.curp}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">RFC</label>
          <input
            type="text"
            name="rfc"
            value={formData.rfc}
            onChange={handleChange}
            className="input-form-1"
          />
          </div>
          <div className="input-group">
          <label className="label2">Puesto&nbsp;</label>
          <input
            type="text"
            name="puesto"
            value={formData.puesto}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">Fecha de ingreso</label>
          <input
            type="date"
            name="fecha_ingreso"
            value={formData.fecha_ingreso}
            onChange={handleChange}
            className="input-form-1"
          />
          </div>
          <div className="input-group">
          <label className="label2">Supervisor</label>
          <input
            type="text"
            name="supervisor"
            value={formData.supervisor}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label3">Proyecto</label>
            <select
              name="id_proyecto"
              value={formData.id_proyecto}
              onChange={handleChange}
              className="input-form-1"
            >
              <option value="1">ADSER</option>
              <option value="2">MIMSA</option>
            </select>
          </div>      

        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <br />
      <hr />
      <br /><br />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por nombres..."
          className="input2"
        />
      </div>
      {filteredEmpleados.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th colSpan="2"></th>
              <th>ID</th>
              <th>Tratamiento</th>
              <th>Nombres</th>
              <th>Apellido Paterno</th>
              <th>Apellido Materno</th>
              <th>Teléfono principal</th>
              <th>Teléfono secundario</th>
              <th>Correo</th>
              <th>Puesto</th>
              <th>Fecha de Nacimiento</th>
              <th>NSS</th>
              <th>CURP</th>
              <th>RFC</th>
              <th>Fecha Ingreso</th>
              <th>Supervisor</th>
              <th>Proyecto</th>
              <th>Usuario</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmpleados.map((Empleados) => (
              <tr key={Empleados.id}>
                <td>
                  <button onClick={() => handleEdit(Empleados)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(Empleados.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
                <td>{Empleados.id}</td>
                <td>{Empleados.tratamiento}</td>
                <td>{Empleados.nombres}</td>
                <td>{Empleados.apellido_paterno}</td>
                <td>{Empleados.apellido_materno}</td>
                <td>{Empleados.telefono_principal}</td>
                <td>{Empleados.telefono_secundario}</td>
                <td>{Empleados.correo}</td>
                <td>{Empleados.puesto}</td>
                <td>{Empleados.fecha_nacimiento}</td>
                <td>{Empleados.nss}</td>
                <td>{Empleados.curp}</td>
                <td>{Empleados.rfc}</td>
                <td>{Empleados.fecha_ingreso}</td>
                <td>{Empleados.supervisor}</td>
                <td>{Empleados.id_proyecto}</td>
                <td>{Empleados.id_usuario}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableEmpleado.propTypes = {
  empleados: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableEmpleado;
